module.exports = __webpack_public_path__ + "img/uv-close.9a145cd5.png";